import React, { useEffect } from 'react';
// import ProductCard from '../components/ProductCard'; // Jika Anda ingin menampilkan produk mikrokontroler

function Mikrokontroler() {
  // --- SEO Meta Tags untuk Halaman Mikrokontroler ---
  useEffect(() => {
    document.title = "Mikrokontroler untuk IoT - Solusi IoT Cerdas | Pilihan Terbaik untuk Proyek Anda";

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "Temukan panduan lengkap mikrokontroler seperti ESP32, ESP8266, Arduino, Raspberry Pi Pico. Pahami peran mereka dalam IoT dan pilih yang tepat untuk proyek Anda.");

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', "mikrokontroler, IoT, ESP32, ESP8266, Arduino, Raspberry Pi Pico, pengembangan IoT, board IoT, belajar IoT");

    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', "https://www.Solusi IoT Cerdas.com/produk/mikrokontroler"); // Ganti dengan URL halaman sebenarnya

    // Cleanup function: Akan dijalankan saat komponen di-unmount
    return () => {
      document.title = "Solusi IoT Cerdas Solusi Cerdas IoT"; // Kembalikan ke judul default aplikasi
    };
  }, []); // Dependensi kosong agar useEffect hanya dijalankan sekali (saat mount)

  return (
    <div className="container mx-auto p-4 md:p-8 bg-gray-50 text-gray-800 font-sans
                    dark:bg-gray-900 dark:text-gray-200 transition-colors duration-500">
      {/* Hero Section */}
      <section
        className="relative bg-gradient-to-br from-indigo-700 to-purple-800 text-white rounded-xl shadow-2xl p-6 md:p-12 mb-12 text-center overflow-hidden
                   dark:from-gray-800 dark:to-black transition-colors duration-500"
        style={{ backgroundImage: 'url(./assets/images/hero-microcontroller.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <div className="absolute inset-0 bg-black opacity-60 rounded-xl"></div>
        <div className="relative z-10">
          <h1 className="text-3xl md:text-5xl font-extrabold text-blue-400 mb-4 animate-fade-in-down">
            Jantung Setiap Perangkat IoT Anda: Mengenal Mikrokontroler
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto mb-8 text-gray-300 animate-fade-in">
            Bayangkan setiap perangkat pintar di sekitar kita memiliki otaknya sendiri—itulah mikrokontroler. Mereka adalah pahlawan tanpa tanda jasa yang memproses data dari sensor, mengendalikan aktuator, dan menghubungkan dunia fisik ke platform Solusi IoT Cerdas Anda. Mari kita selami lebih dalam dan temukan "otak" yang sempurna untuk inovasi Anda!
          </p>
        </div>
      </section>

      {/* What is a Microcontroller Section */}
      <section className="bg-white rounded-xl shadow-lg p-6 md:p-10 mb-12 border border-gray-200
                          dark:bg-gray-800 dark:border-gray-700 dark:shadow-xl transition-colors duration-500">
        <h2 className="text-3xl font-bold text-blue-700 text-center mb-8
                       dark:text-blue-400">
          Apa Sebenarnya Mikrokontroler Itu? <span className="text-blue-500 inline-block animate-pulse-slow">&#9889;</span>
        </h2>
        <div className="flex flex-col md:flex-row items-center gap-8">
          <div className="md:w-1/2">
            <p className="text-lg text-gray-700 mb-6 leading-relaxed
                          dark:text-gray-300">
              Sederhananya, mikrokontroler adalah <strong className="text-blue-600 dark:text-blue-300">komputer mini yang sangat terintegrasi dalam satu *chip* kecil</strong>. Berbeda dengan komputer pribadi kita yang dirancang untuk berbagai macam tugas, mikrokontroler dibuat khusus untuk menjalankan satu atau beberapa fungsi spesifik secara berulang. Mereka adalah tulang punggung perangkat IoT Anda, mampu:
            </p>
            <ul className="list-none p-0 text-gray-600 space-y-3 dark:text-gray-400">
              <li className="flex items-start gap-3">
                <span className="text-blue-500 text-2xl font-bold flex-shrink-0">&#10003;</span>
                <p><strong className="text-blue-600 dark:text-blue-300">Mengumpulkan Data:</strong> Menerima informasi dari berbagai sensor (suhu, kelembaban, tekanan, gerakan, dll.).</p>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-blue-500 text-2xl font-bold flex-shrink-0">&#10003;</span>
                <p><strong className="text-blue-600 dark:text-blue-300">Memproses Informasi:</strong> Menganalisis data sensor dan mengambil keputusan berdasarkan program yang Anda tulis.</p>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-blue-500 text-2xl font-bold flex-shrink-0">&#10003;</span>
                <p><strong className="text-blue-600 dark:text-blue-300">Mengendalikan Aktuator:</strong> Memberikan perintah ke komponen fisik (motor, lampu, *relay*) untuk melakukan tindakan.</p>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-blue-500 text-2xl font-bold flex-shrink-0">&#10003;</span>
                <p><strong className="text-blue-600 dark:text-blue-300">Berkomunikasi:</strong> Mengirim dan menerima data ke dan dari platform Solusi IoT Cerdas Anda melalui jaringan.</p>
              </li>
            </ul>
          </div>
          <div className="md:w-1/2 flex justify-center items-center">
            <div className="bg-gray-100 p-8 rounded-lg shadow-inner w-full max-w-sm aspect-video flex items-center justify-center border-2 border-blue-500
                            dark:bg-gray-700 dark:border-blue-700 transition-colors duration-500">
              <span className="text-blue-600 text-3xl font-bold dark:text-blue-300">MCU Core</span>
            </div>
          </div>
        </div>
      </section>

      {/* Types of Microcontrollers Section */}
      <section className="bg-white rounded-xl shadow-lg p-6 md:p-10 mb-12 border border-gray-200
                          dark:bg-gray-800 dark:border-gray-700 dark:shadow-xl transition-colors duration-500">
        <h2 className="text-3xl font-bold text-blue-700 text-center mb-8
                       dark:text-blue-400">
          Kenali Pahlawan-Pahlawan Mikrokontroler untuk Proyek IoT Anda!
        </h2>
        <p className="text-lg text-gray-700 text-center mb-8 max-w-3xl mx-auto dark:text-gray-300">
          Dunia IoT dipenuhi dengan beragam mikrokontroler, masing-masing dengan kekuatan supernya sendiri. Memilih yang tepat bisa jadi tantangan, tapi jangan khawatir! Berikut adalah beberapa bintang lapangan yang paling sering digunakan, lengkap dengan ciri khasnya:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* ESP32 */}
          <div className="bg-gray-50 rounded-lg p-6 shadow-md border border-blue-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-blue-600 dark:shadow-lg">
            <h3 className="text-2xl font-bold text-blue-600 mb-4 flex items-center gap-3 dark:text-blue-300">
              <img src="./assets/images/esp32-board.png" alt="ESP32 Board" className="w-24 h-auto rounded-md shadow-md" />
              ESP32 <span className="text-sm text-gray-500 dark:text-gray-400">(Sang Multitalenta)</span>
            </h3>
            <ul className="text-gray-700 list-none p-0 space-y-2 dark:text-gray-400">
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Konektivitas Lengkap:</strong> WiFi dan Bluetooth Low Energy (BLE) terintegrasi, siap untuk setiap skenario nirkabel.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Performa Kuat:</strong> Prosesor dual-core dan banyak pin I/O menjadikannya pilihan ideal untuk proyek kompleks yang butuh kecepatan dan banyak koneksi.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Kasus Penggunaan:</strong> Jantung untuk sistem *smart home*, otomatisasi industri, monitor lingkungan lanjutan.</p>
              </li>
            </ul>
          </div>

          {/* ESP8266 */}
          <div className="bg-gray-50 rounded-lg p-6 shadow-md border border-blue-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-blue-600 dark:shadow-lg">
            <h3 className="text-2xl font-bold text-blue-600 mb-4 flex items-center gap-3 dark:text-blue-300">
              <img src="./assets/images/esp8266-board.png" alt="ESP8266 Board" className="w-24 h-auto rounded-md shadow-md" />
              ESP8266 <span className="text-sm text-gray-500 dark:text-gray-400">(Si Ekonomis & Ramah Pemula)</span>
            </h3>
            <ul className="text-gray-700 list-none p-0 space-y-2 dark:text-gray-400">
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Harga Terjangkau & Efisien:</strong> Pilihan favorit untuk memulai proyek IoT berkat harganya yang bersahabat dan konsumsi daya yang efisien.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">WiFi Saja:</strong> Fokus utama pada konektivitas WiFi, sempurna untuk mengirim data sensor sederhana ke cloud.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Kasus Penggunaan:</strong> Sensor suhu/kelembaban nirkabel, kontrol lampu pintar, atau perangkat sederhana lainnya.</p>
              </li>
            </ul>
          </div>

          {/* Arduino */}
          <div className="bg-gray-50 rounded-lg p-6 shadow-md border border-blue-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-blue-600 dark:shadow-lg">
            <h3 className="text-2xl font-bold text-blue-600 mb-4 flex items-center gap-3 dark:text-blue-300">
              <img src="./assets/images/arduino-board.png" alt="Arduino Board" className="w-24 h-auto rounded-md shadow-md" />
              Arduino <span className="text-sm text-gray-500 dark:text-gray-400">(Guru Para Pemula)</span>
            </h3>
            <ul className="text-gray-700 list-none p-0 space-y-2 dark:text-gray-400">
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Sangat Ramah Pemula:</strong> Dikenal dengan kemudahan penggunaan, komunitas besar, dan ekosistem *shield* (ekstensi) yang melimpah.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Fleksibel:</strong> Cocok untuk prototipe cepat dan proyek yang tidak memerlukan konektivitas nirkabel bawaan (bisa ditambahkan dengan modul).</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Kasus Penggunaan:</strong> Proyek pendidikan, robotika sederhana, kontrol perangkat mekanik.</p>
              </li>
            </ul>
          </div>

          {/* Raspberry Pi Pico */}
          <div className="bg-gray-50 rounded-lg p-6 shadow-md border border-blue-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-blue-600 dark:shadow-lg">
            <h3 className="text-2xl font-bold text-blue-600 mb-4 flex items-center gap-3 dark:text-blue-300">
              <img src="./assets/images/pi-pico-board.png" alt="Raspberry Pi Pico Board" className="w-24 h-auto rounded-md shadow-md" />
              Raspberry Pi Pico <span className="text-sm text-gray-500 dark:text-gray-400">(Performa Terjangkau)</span>
            </h3>
            <ul className="text-gray-700 list-none p-0 space-y-2 dark:text-gray-400">
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Performa Unggul dengan Biaya Rendah:</strong> Ditenagai chip RP2040, menawarkan daya komputasi yang luar biasa untuk harganya.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Dukungan Bahasa:</strong> Fleksibel dengan dukungan MicroPython dan C++, cocok untuk pengembang dengan berbagai latar belakang.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Kasus Penggunaan:</strong> Proyek robotika, *embedded machine learning* (TinyML), kontrol presisi.</p>
              </li>
            </ul>
          </div>

          {/* NodeMCU (berbasis ESP8266) */}
          <div className="bg-gray-50 rounded-lg p-6 shadow-md border border-blue-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-blue-600 dark:shadow-lg">
            <h3 className="text-2xl font-bold text-blue-600 mb-4 flex items-center gap-3 dark:text-blue-300">
              <img src="./assets/images/nodemcu-board.png" alt="NodeMCU Board" className="w-24 h-auto rounded-md shadow-md" />
              NodeMCU <span className="text-sm text-gray-500 dark:text-gray-400">(Platform Development Mudah)</span>
            </h3>
            <ul className="text-gray-700 list-none p-0 space-y-2 dark:text-gray-400">
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Mudah Diprogram:</strong> Berbasis ESP8266, dilengkapi dengan *firmware* berbasis Lua atau dapat diprogram dengan Arduino IDE.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Board Lengkap:</strong> Sudah memiliki *USB-to-Serial converter* dan *voltage regulator*, sangat praktis untuk prototipe.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Kasus Penggunaan:</strong> Proyek yang butuh *rapid prototyping* dengan koneksi WiFi, *smart home* sederhana.</p>
              </li>
            </ul>
          </div>

          {/* Adafruit Feather / Particle Photon (contoh lain) */}
          <div className="bg-gray-50 rounded-lg p-6 shadow-md border border-blue-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-blue-600 dark:shadow-lg">
            <h3 className="text-2xl font-bold text-blue-600 mb-4 flex items-center gap-3 dark:text-blue-300">
              <img src="./assets/images/adafruit-feather-board.png" alt="Adafruit Feather Board" className="w-24 h-auto rounded-md shadow-md" />
              Adafruit Feather / Particle Photon <span className="text-sm text-gray-500 dark:text-gray-400">(Spesialis Seluler/Portabel)</span>
            </h3>
            <ul className="text-gray-700 list-none p-0 space-y-2 dark:text-gray-400">
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Desain Ramping & Bertenaga Baterai:</strong> Sempurna untuk proyek portabel dengan ruang terbatas.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Konektivitas Beragam:</strong> Banyak varian termasuk WiFi, Bluetooth, LoRa, atau bahkan Cellular (LTE/NB-IoT).</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Kasus Penggunaan:</strong> Pelacakan aset, perangkat wearable, sensor lapangan jarak jauh.</p>
              </li>
            </ul>
          </div>

          {/* Microcontrollers for Education/Beginners */}
          <div className="bg-gray-50 rounded-lg p-6 shadow-md border border-blue-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-blue-600 dark:shadow-lg">
            <h3 className="text-2xl font-bold text-blue-600 mb-4 flex items-center gap-3 dark:text-blue-300">
              <img src="./assets/icons/icon-easy-setup.png" alt="Education Icon" className="w-24 h-auto rounded-md shadow-md" />
              Mikrokontroler untuk Edukasi & Pemula
            </h3>
            <ul className="text-gray-700 list-none p-0 space-y-2 dark:text-gray-400">
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Micro:bit:</strong> Sangat mudah untuk belajar *coding* dan elektronik, dengan fitur dasar seperti LED matrix dan sensor bawaan.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">ESP32/ESP8266 Development Boards:</strong> Banyak papan pengembangan ini dirancang agar mudah digunakan oleh pemula, dengan pin yang mudah diakses dan dukungan IDE yang baik.</p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-700 dark:text-blue-200">&#10003;</span>
                <p><strong className="text-blue-700 dark:text-blue-200">Kasus Penggunaan:</strong> Workshop, kursus coding, proyek hobi pertama.</p>
              </li>
            </ul>
          </div>

        </div>
      </section>

      {/* How Microcontrollers Interact Section */}
      <section className="bg-white rounded-xl shadow-lg p-6 md:p-10 mb-12 border border-gray-200
                          dark:bg-gray-800 dark:border-gray-700 dark:shadow-xl transition-colors duration-500">
        <h2 className="text-3xl font-bold text-blue-700 text-center mb-8
                       dark:text-blue-400">
          Bagaimana Mikrokontroler Berinteraksi dengan Solusi IoT Cerdas Anda?
        </h2>
        <p className="text-lg text-gray-700 text-center mb-8 max-w-3xl mx-auto dark:text-gray-300">
          Hubungan antara mikrokontroler Anda dan platform Solusi IoT Cerdas kami adalah sinergi sempurna yang mengubah ide menjadi solusi nyata. Begini alurnya:
        </p>
        <div className="flex justify-center items-center">
          <img src="./assets/images/iot-flow-diagram.png" alt="IoT Data Flow Diagram" className="max-w-full h-auto rounded-lg shadow-xl border border-gray-300 dark:border-gray-700 animate-fade-in" />
        </div>
        <ol className="list-decimal list-inside text-gray-700 space-y-4 text-lg mt-8 max-w-4xl mx-auto dark:text-gray-300">
          <li className="flex items-start gap-3">
            <span className="text-blue-500 text-2xl font-bold flex-shrink-0">&#x2713;</span> {/* Centang */}
            <div>
              <strong className="text-blue-600 dark:text-blue-300">Pengambilan Data dari Sensor:</strong> Mikrokontroler Anda ibarat mata dan telinga perangkat IoT. Ia membaca sinyal dari sensor — entah itu suhu ruangan, kelembaban tanah, atau gerakan — dan mengubahnya menjadi data digital.
            </div>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-blue-500 text-2xl font-bold flex-shrink-0">&#x2713;</span>
            <div>
              <strong className="text-blue-600 dark:text-blue-300">Pemrosesan Awal (Jika Diperlukan):</strong> Terkadang, mikrokontroler dapat melakukan sedikit "berpikir" sendiri. Misalnya, memfilter data noise atau melakukan perhitungan dasar sebelum mengirimkannya. Ini menghemat bandwidth dan daya.
            </div>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-blue-500 text-2xl font-bold flex-shrink-0">&#x2713;</span>
            <div>
              <strong className="text-blue-600 dark:text-blue-300">Koneksi ke Jaringan:</strong> Melalui modul WiFi, Bluetooth, atau bahkan Ethernet, mikrokontroler Anda terhubung ke internet, menjadi bagian dari jaringan global.
            </div>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-blue-500 text-2xl font-bold flex-shrink-0">&#x2713;</span>
            <div>
              <strong className="text-blue-600 dark:text-blue-300">Pengiriman Data ke Solusi IoT Cerdas:</strong> Dengan protokol yang aman, data sensor yang sudah diproses dikirimkan ke *cloud backend* Solusi IoT Cerdas Anda. Di sinilah data diarsipkan, dianalisis, dan ditampilkan di *dashboard* yang mudah Anda pahami.
            </div>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-blue-500 text-2xl font-bold flex-shrink-0">&#x2713;</span>
            <div>
              <strong className="text-blue-600 dark:text-blue-300">Menerima Perintah dari Solusi IoT Cerdas:</strong> Bukan hanya satu arah! Anda juga bisa mengirimkan perintah dari *dashboard* Solusi IoT Cerdas ke mikrokontroler untuk mengontrol aktuator. Misalnya, menyalakan lampu dari jarak jauh, membuka gerbang, atau menyesuaikan suhu.
            </div>
          </li>
        </ol>
      </section>

      {/* Choosing Guide Section */}
      <section className="bg-white rounded-xl shadow-lg p-6 md:p-10 mb-12 border border-gray-200
                          dark:bg-gray-800 dark:border-gray-700 dark:shadow-xl transition-colors duration-500">
        <h2 className="text-3xl font-bold text-blue-700 text-center mb-8
                       dark:text-blue-400">
          Bagaimana Memilih "Otak" yang Tepat untuk Proyek IoT Anda?
        </h2>
        <p className="text-lg text-gray-700 text-center mb-8 max-w-3xl mx-auto dark:text-gray-300">
          Memilih mikrokontroler yang paling cocok adalah langkah penting. Pertimbangkan faktor-faktor ini:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-gray-700 dark:shadow-lg">
            <h3 className="text-xl font-semibold text-blue-600 mb-3 flex items-center gap-2 dark:text-blue-300">
              <img src="./assets/icons/icon-wifi-signal.png" alt="Connectivity Icon" className="w-6 h-6" />
              Kebutuhan Konektivitas
            </h3>
            <p className="text-gray-700 dark:text-gray-400">Apakah proyek Anda mutlak membutuhkan WiFi dan/atau Bluetooth bawaan? Atau cukup dengan koneksi kabel/modul tambahan?</p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-gray-700 dark:shadow-lg">
            <h3 className="text-xl font-semibold text-blue-600 mb-3 flex items-center gap-2 dark:text-blue-300">
              <img src="./assets/icons/icon-chip.png" alt="Compute Icon" className="w-6 h-6" />
              Daya Komputasi & Memori
            </h3>
            <p className="text-gray-700 dark:text-gray-400">Seberapa kompleks tugas yang akan dijalankan? Apakah akan ada banyak sensor, pemrosesan data di perangkat, atau algoritma yang rumit?</p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-gray-700 dark:shadow-lg">
            <h3 className="text-xl font-semibold text-blue-600 mb-3 flex items-center gap-2 dark:text-blue-300">
              <img src="./assets/icons/icon-easy-setup.png" alt="IO Pin Icon" className="w-6 h-6" />
              Jumlah & Jenis Pin I/O
            </h3>
            <p className="text-gray-700 dark:text-gray-400">Berapa banyak sensor atau aktuator yang ingin Anda hubungkan? Apakah Anda memerlukan pin analog, digital, PWM, atau antarmuka komunikasi spesifik (I2C, SPI, UART)?</p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-gray-700 dark:shadow-lg">
            <h3 className="text-xl font-semibold text-blue-600 mb-3 flex items-center gap-2 dark:text-blue-300">
              <img src="./assets/icons/icon-power-plug.png" alt="Power Icon" className="w-6 h-6" />
              Konsumsi Daya
            </h3>
            <p className="text-gray-700 dark:text-gray-400">Apakah perangkat Anda akan beroperasi dengan baterai? Jika ya, fitur hemat daya dan efisiensi energi menjadi sangat penting.</p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-gray-700 dark:shadow-lg">
            <h3 className="text-xl font-semibold text-blue-600 mb-3 flex items-center gap-2 dark:text-blue-300">
              <img src="./assets/icons/icon-cost.png" alt="Cost Icon" className="w-6 h-6" />
              Anggaran & Ukuran Fisik
            </h3>
            <p className="text-gray-700 dark:text-gray-400">Berapa anggaran Anda? Apakah ukuran fisik perangkat sangat krusial untuk penempatan di dalam casing atau produk akhir?</p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-300 transform hover:scale-102 transition-all duration-300
                          dark:bg-gray-900 dark:border-gray-700 dark:shadow-lg">
            <h3 className="text-xl font-semibold text-blue-600 mb-3 flex items-center gap-2 dark:text-blue-300">
              <img src="./assets/icons/icon-brain.png" alt="Learning Icon" className="w-6 h-6" />
              Tingkat Kemudahan Belajar
            </h3>
            <p className="text-gray-700 dark:text-gray-400">Apakah Anda pemula, hobiis, atau *developer* berpengalaman? Beberapa platform lebih ramah pemula daripada yang lain (misalnya, Arduino sangat direkomendasikan untuk awal).</p>
          </div>
        </div>
      </section>

      {/* Getting Started Section */}
      <section className="bg-gradient-to-r from-blue-500 to-indigo-600 rounded-xl shadow-lg p-6 md:p-10 text-center
                          dark:from-blue-700 dark:to-indigo-800 transition-colors duration-500">
        <h2 className="text-3xl font-bold text-white mb-6 animate-fade-in">
          Siap Memulai Petualangan IoT Anda?
        </h2>
        <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto dark:text-blue-200">
          Solusi IoT Cerdas menyediakan panduan dan infrastruktur yang mudah untuk mengintegrasikan mikrokontroler pilihan Anda. Dari konsep hingga implementasi, kami siap mendukung Anda. Mulai koding, hubungkan, dan saksikan proyek IoT Anda berjalan dengan mulus!
        </p>
        <button
          className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-lg text-xl transition-all duration-300 ease-in-out transform hover:scale-105 shadow-lg"
          onClick={() => alert('Link ke Panduan Memulai Mikrokontroler atau Dokumentasi API!')}
        >
          Pelajari Panduan & Dokumentasi Sekarang
        </button>
      </section>

      {/* Optional: Related Products Section */}
      {/* <section className="bg-white rounded-xl shadow-lg p-6 md:p-8 mt-12 border border-gray-200
                          dark:bg-gray-800 dark:border-gray-700 dark:shadow-xl transition-colors duration-500">
        <h2 className="text-3xl font-bold text-blue-700 text-center mb-6 dark:text-blue-400">Produk Mikrokontroler Rekomendasi</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Contoh ProductCard Anda
          <ProductCard product={{ id: "esp32-dev", nama: "ESP32 Dev Board", harga: 75000 }} />
          <ProductCard product={{ id: "nodemcu-v3", nama: "NodeMCU ESP8266 V3", harga: 40000 }} />
          <ProductCard product={{ id: "arduino-uno", nama: "Arduino Uno R3", harga: 100000 }} />
          }
        </div>
      </section> */}
    </div>
  );
}

export default Mikrokontroler;